import { BaseField } from "./BaseField";
import { ExtractedData } from "./ExtractedData";

/**
 * Store the returned extraction results for a DLF, and cache matcher extractions to
 * avoid slow API calls.
 */
class ExtractedFieldData extends ExtractedData<BaseField> {
  /**
   * Store each matcher ID against an extraction result.
   */
  _reuseCache: {
    [x in string]: BaseField;
  } = {};

  /**
   * insert an extracted field into the reuse cache.
   * @param baseField
   * @returns
   */
  override put(baseField: BaseField | undefined): boolean {
    let set = false;

    if (
      baseField && // defined
      !baseField._requireExtract && // extracted and has matcher data
      baseField._matcherData != undefined &&
      baseField.matcherId !== ""
    ) {
      this._reuseCache[baseField.matcherId] = baseField;
      set = true;
    }

    return set;
  }

  override extractToReuse(entry: BaseField | undefined): BaseField | undefined {
    return entry;
  }

  override setReuse(reuseResults: BaseField[]) {
    // console.log('a:' + reuseResults.length);
    let modifiedReuse: BaseField[] =
      ExtractedFieldData.markInitialReuseNotAllowEmpty(reuseResults);
    // console.log('b:' + modifiedReuse.length);
    // deduplicate
    modifiedReuse = ExtractedFieldData.removeDuplicates(modifiedReuse);
    // console.log('c:' + modifiedReuse.length);
    modifiedReuse = ExtractedFieldData.removeRequireExtraction(modifiedReuse);
    // console.log('d:' + modifiedReuse.length);
    modifiedReuse = modifiedReuse.filter(
      (x) => !x.extractedById(this.extraction?.matcherId),
    );
    // console.log('e:' + modifiedReuse.length);

    super.setReuse(modifiedReuse);

    this._reuse.forEach((x) => this.put(x));
  }

  /**
   * Select the first reuse result for each matcher ID.
   */
  static removeDuplicates(
    baseFields: Array<BaseField | undefined>,
  ): BaseField[] {
    return baseFields
      .filter((x) => x != undefined)
      .filter(
        (r, i, arr) =>
          arr.findIndex((x) => x!.matcherId === r!.matcherId) === i,
      ) as BaseField[];
  }

  /**
   * Remove base fields requiring extraction
   */
  static removeRequireExtraction(
    baseFields: Array<BaseField | undefined>,
  ): BaseField[] {
    return baseFields
      .filter((x) => x != undefined)
      .filter((x) => !x!._requireExtract) as BaseField[];
  }

  /**
   * Set a list of BaseFields as allowEmpty=false. This is a hacky, but efficient, way of resetting
   * these values.
   * @param reuse
   */
  static markInitialReuseNotAllowEmpty(reuse: BaseField[]): BaseField[] {
    reuse.forEach((r) => {
      //@ts-expect-error
      if (r.matcherData.allowEmpty != null) {
        //@ts-expect-error
        r.matcherData.allowEmpty = false;
      }
    });
    return reuse;
  }
}

export { ExtractedFieldData };
